import styled from 'styled-components';
export const CardSelectorContainer = styled.div`
  background-color: ${_ref => {
  let {
    theme
  } = _ref;
  return theme.colors.secondary;
}};
  border-radius: 8px;
  display: flex;
  height: 150px;
  justify-content: center;
  overflow: hidden;
  padding: 24px;
  width: 100%;
`;
export const ItemsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  cursor: grab;
`;
export const ItemContainer = styled.div`
  background-color: ${_ref2 => {
  let {
    theme,
    selected
  } = _ref2;
  return selected ? theme.colors.secondaryL2 : theme.colors.secondaryL1;
}};
  border-radius: ${_ref3 => {
  let {
    size
  } = _ref3;
  return size === 'sm' ? '10px' : '15px';
}};
  border: 1px solid transparent;
  cursor: pointer;
  display: flex;
  height: 100%;
  width: 100%;
  justify-content: center;
  align-items: center;
  min-width: ${_ref4 => {
  let {
    size
  } = _ref4;
  return size === 'sm' ? '92px' : '120px';
}};

  ${_ref5 => {
  let {
    disabled
  } = _ref5;
  return disabled && `
    cursor: not-allowed;
    pointer-events: none;
    opacity: 0.3;
    `;
}}

  &:focus {
    outline: none;
    border: 1px solid ${_ref6 => {
  let {
    theme
  } = _ref6;
  return theme.colors.secondaryL3;
}};
  }
`;
export const IconContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 64px;
  justify-content: center;
`;
export const IconBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: ${_ref7 => {
  let {
    size
  } = _ref7;
  return size === 'sm' ? '48px' : '56px';
}};
  width: ${_ref8 => {
  let {
    size
  } = _ref8;
  return size === 'sm' ? '48px' : '56px';
}};
`;
export const LabelText = styled.span`
  ${_ref9 => {
  let {
    theme,
    size
  } = _ref9;
  return size === 'sm' ? theme.fonts.infoSM : theme.fonts.infoLG;
}}
  color: ${_ref10 => {
  let {
    theme
  } = _ref10;
  return theme.colors.neutralL5;
}};
  user-select: none;
`;